import Site from './Models/Site'
import Dealer from './Models/Dealer'
import Project from './Models/Project'
import Attribute from './Models/Attribute'
import AttributeOption from './Models/AttributeOption'

Vue.prototype.$models.$site = new Vue(Site)
Vue.prototype.$models.$dealer = new Vue(Dealer)
Vue.prototype.$models.$project = new Vue(Project)
Vue.prototype.$models.$attribute = new Vue(Attribute)
Vue.prototype.$models.$attributeOption = new Vue(AttributeOption)

Vue.component('video-section', () => import(/* webpackChunkName: "video-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VideoSection'))
Vue.component('we-create-section', () => import(/* webpackChunkName: "we-create-section" */ '@modulesPages/Site/Resources/assets/js/Sections/WeCreateSection'))
Vue.component('profile-section', () => import(/* webpackChunkName: "profile-section" */ '@modulesPages/Site/Resources/assets/js/Sections/ProfileSection'))
Vue.component('contact-section', () => import(/* webpackChunkName: "contact-section" */ '@modulesPages/Site/Resources/assets/js/Sections/ContactSection'))
Vue.component('persons-section', () => import(/* webpackChunkName: "persons-section" */ '@modulesPages/Site/Resources/assets/js/Sections/PersonsSection'))
Vue.component('locations-section', () => import(/* webpackChunkName: "locations-section" */ '@modulesPages/Site/Resources/assets/js/Sections/LocationsSection'))
Vue.component('points-section', () => import(/* webpackChunkName: "points-section" */ '@modulesPages/Site/Resources/assets/js/Sections/PointsSection'))
Vue.component('images-section', () => import(/* webpackChunkName: "images-section" */ '@modulesPages/Site/Resources/assets/js/Sections/ImagesSection'))
Vue.component('become-dealer-section', () => import(/* webpackChunkName: "become-dealer-section" */ '@modulesPages/Site/Resources/assets/js/Sections/BecomeDealerSection'))
Vue.component('project-header-section', () => import(/* webpackChunkName: "project-header-section" */ '@modulesPages/Site/Resources/assets/js/Sections/ProjectHeaderSection'))
Vue.component('random-gallery-section', () => import(/* webpackChunkName: "random-gallery-section" */ '@modulesPages/Site/Resources/assets/js/Sections/RandomGallerySection'))
Vue.component('find-dealer-section', () => import(/* webpackChunkName: "find-dealer-section" */ '@modulesPages/Site/Resources/assets/js/Sections/FindDealerSection'))

Vue.component('dealers-form', () => import(/* webpackChunkName: "dealers-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Dealers/DealersForm'))
Vue.component('dealers-form2', () => import(/* webpackChunkName: "dealers-form2" */ '@modulesPages/Site/Resources/assets/js/Forms/Dealers/DealersForm2'))
Vue.component('projects-form', () => import(/* webpackChunkName: "projects-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Projects/ProjectsForm'))
Vue.component('attributes-form', () => import(/* webpackChunkName: "attributes-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Attributes/AttributesForm'))
Vue.component('attribute-options-form', () => import(/* webpackChunkName: "attribute-options-form" */ '@modulesPages/Site/Resources/assets/js/Forms/AttributeOptions/AttributeOptionsForm'))

Vue.component('dealers-table', () => import(/* webpackChunkName: "dealers-table" */ '@modulesPages/Site/Resources/assets/js/Tables/DealersTable'))
Vue.component('projects-table', () => import(/* webpackChunkName: "projects-table" */ '@modulesPages/Site/Resources/assets/js/Tables/ProjectsTable'))
Vue.component('attributes-table', () => import(/* webpackChunkName: "attributes-table" */ '@modulesPages/Site/Resources/assets/js/Tables/AttributesTable'))
Vue.component('attribute-options-table', () => import(/* webpackChunkName: "attribute-options-table" */ '@modulesPages/Site/Resources/assets/js/Tables/AttributeOptionsTable'))

Vue.component('category-selector', () => import(/* webpackChunkName: "category-selector" */ '@modulesPages/Site/Resources/assets/js/Components/CategorySelector'))
Vue.component('change-password-button', () => import(/* webpackChunkName: "change-password-button" */ '@modulesPages/Site/Resources/assets/js/Components/ChangePasswordButton'))
Vue.component('simple-banner', () => import(/* webpackChunkName: "simple-banner" */ '@modulesPages/Site/Resources/assets/js/Components/SimpleBanner'))
Vue.component('map-sidebar', () => import(/* webpackChunkName: "map-sidebar" */ '@modulesPages/Site/Resources/assets/js/Components/MapSidebar'))
Vue.component('product-breadcrumbs', () => import(/* webpackChunkName: "product-breadcrumbs" */ '@modulesPages/Site/Resources/assets/js/Components/ProductBreadcrumbs'))
Vue.component('message-modal', () => import(/* webpackChunkName: "message-modal" */ '@modulesPages/Site/Resources/assets/js/Components/MessageModal'))
Vue.component('imp-exp-products-component', () => import(/* webpackChunkName: "imp-exp-products-component" */ '@modulesPages/Site/Resources/assets/js/Components/ImpExpProductsComponent'))

Vue.component('gallery', () => import(/* webpackChunkName: "gallery" */ '@modulesPages/Site/Resources/assets/js/Gallery/Gallery'))
Vue.component('gallery-item', () => import(/* webpackChunkName: "gallery-item" */ '@modulesPages/Site/Resources/assets/js/Gallery/GalleryItem'))
Vue.component('zoom', () => import(/* webpackChunkName: "zoom" */ '@modulesPages/Site/Resources/assets/js/Gallery/Zoom'))

Vue.component('dealers-card', () => import(/* webpackChunkName: "dealers-card" */ '@modulesPages/Site/Resources/assets/js/Cards/DealersCard'))
Vue.component('dealers-card2', () => import(/* webpackChunkName: "dealers-card2" */ '@modulesPages/Site/Resources/assets/js/Cards/DealersCard2'))
Vue.component('projects-card', () => import(/* webpackChunkName: "projects-card" */ '@modulesPages/Site/Resources/assets/js/Cards/ProjectsCard'))
Vue.component('projects-card2', () => import(/* webpackChunkName: "projects-card2" */ '@modulesPages/Site/Resources/assets/js/Cards/ProjectsCard2'))
Vue.component('persons-card', () => import(/* webpackChunkName: "persons-card" */ '@modulesPages/Site/Resources/assets/js/Cards/PersonsCard'))
Vue.component('gallery-card', () => import(/* webpackChunkName: "gallery-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GalleryCard'))

Vue.component('google-map', () => import(/* webpackChunkName: "google-map" */ '@modulesPages/Site/Resources/assets/js/Map/GoogleMap'))
Vue.component('google-map-loader', () => import(/* webpackChunkName: "google-map-loader" */ '@modulesPages/Site/Resources/assets/js/Map/GoogleMapLoader'))
Vue.component('google-map-marker', () => import(/* webpackChunkName: "google-map-marker" */ '@modulesPages/Site/Resources/assets/js/Map/GoogleMapMarker'))
Vue.component('google-map-cluster', () => import(/* webpackChunkName: "google-map-cluster" */ '@modulesPages/Site/Resources/assets/js/Map/GoogleMapCluster'))

app.$set(app.$state, 'filters', {
    categories: [],
    categoriesAndParents: [],
    collection: {},
    category: {},

    clickCategory() {
        //
    }
});

app.$set(app.$models.$category, 'tree', app.$state.tree)

app.$set(app.$state, 'product', {})
app.$set(app.$state, 'item', {})

app.$set(app.$state, 'isMode', (mode) => {
	return app.$state.user && app.$state.user.mode == mode
})

app.$set(app.$state, 'canBuy', () => {
	return app.$state.isMode('dealer') && app.$state.user.dealer.can_buy
})

app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
    	'Modules\\Site\\Entities\\Dealer': 'Dealer',
        'Modules\\Site\\Entities\\Project': 'Proyecto',
        'Modules\\Site\\Entities\\Attribute': 'Atributo',
        'Modules\\Site\\Entities\\AttributeOption': 'Opción de Atributo',
    }   
}

app.$Util.tableNameByClassName = {
    ...app.$Util.tableNameByClassName,
    ...{
    	'Modules\\Site\\Entities\\Dealer': 'dealers',
        'Modules\\Site\\Entities\\Project': 'projects',
        'Modules\\Site\\Entities\\Atribute': 'attributes',
        'Modules\\Site\\Entities\\AtributeOption': 'attribute-options',
    }   
}

app.$Util.classNameByTableName = {
    ...app.$Util.classNameByTableName,
    ...{
    	'dealers': 'Modules\\Site\\Entities\\Dealer',
        'projects': 'Modules\\Site\\Entities\\Project',
        'attributes': 'Modules\\Site\\Entities\\Attribute',
        'attribute-options': 'Modules\\Site\\Entities\\AttributeOption',
    }   
}

app.$Util.formattedStatus = {
	...app.$Util.formattedStatus,
	...{
		'confirmed': 'Confirmado',
	}	
}

app.$set(app.$state, 'site', {
    alert: {},

    //  Menu web visible
    menu: false,

    facebook: {
        text: '@tablesandmore.tm',
        url: 'https://www.facebook.com/tablesandmore.tm'
    },
    instagram: {
        text: '@tablesandmore.tm',
        url: 'https://www.instagram.com/tables.more/'
    },
    twitter: {
        text: '@tablesnmore',
        url: 'https://twitter.com/TablesMore'
    },
    pinterest: {
        text: '@tablesandmore',
        url: 'https://www.pinterest.com.mx/Tables_More'
    },
    email: {
        text: 'contact@tablesandmore.com',
        url: 'mailto:contact@tablesandmore.com',
    },
    warehouseLocation: {
        title: 'USA Warehouse',
        text: [
            '402 E. Lachapelle 78204',
            'San Antonio, TX, USA.'
        ],
        phone: {
            text: '+1 210 609 0313',
            url: 'tel:+12106090313',
        },
        url: 'https://g.page/tables-and-more-san-antonio?share'
    },
    factoryLocation: {
        title: 'Factory & Offices',
        text: [
            'San Marcos #994 Los Cajetes',
            '45234 Zapopan, Jalisco, Mexico.'
        ],
        phone: {
            text: '+52 33 3124 6952 / 53',
            url: '#',
        },
        url: 'https://goo.gl/maps/oyJXxWEVLH2QdBmQ9'
    }
})

app.$set(app.$state, 'cart', {})

if(
    app.$state.scope == 'web'
    && app.$state.isMode('dealer')
) {
	app.$cart.content()
}

app.$set(app.$state, 'gallery', {
	images: [],
	index: null,
	open(index, images) {
		app.$set(app.$state.gallery, 'images', images)
		app.$set(app.$state.gallery, 'index', index)
	},
    close() {
		app.$set(app.$state.gallery, 'index', null)
	}
})